"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function namespaceOverrides(flatOverrides) {
    return Object.keys(flatOverrides).reduce((acc, key) => {
        const [namespace, name] = key.split('/');
        if (!namespace || !name) {
            return acc;
        }
        const accNamespace = acc[namespace] || {};
        return Object.assign(Object.assign({}, acc), { [namespace]: Object.assign(Object.assign({}, accNamespace), { [name]: flatOverrides[key] }) });
    }, {});
}
exports.default = namespaceOverrides;
//# sourceMappingURL=namespace-overrides.js.map